import { Component, OnInit } from '@angular/core';
import { ConnectionService } from '@services/connection-service';
import { DietPlanV2Component } from './diet-plan-v2/diet-plan-v2.component';

@Component({
  selector: 'notice',
  templateUrl: './notice.html',
  imports: [DietPlanV2Component],
})
export class NoticeComponent implements OnInit {
  user: any;

  constructor(private readonly conn: ConnectionService) {}

  ngOnInit(): void {
    this.user = this.conn.getActingUser();
  }
}
